module.exports = __webpack_public_path__ + "static/img/klein-niki-800px.d15730b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/klein-niki-800px.png
// module id = sGTC
// module chunks = 2